import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
const CannotPublishRally = ({ rallyId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const goToTasksList = async () => {
        navigate(generateIdRoutePath(APP_ROUTES.adminManageTasks, rallyId));
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    return (_jsxs("div", { className: 'modal-content cannot-publish-rally', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.cannot-publish-rally'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.manage_tasks'), onClick: goToTasksList }), _jsx(Button, { variant: 'outlined', label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } })] }) })] }));
};
export default CannotPublishRally;
